var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.946 9.24l-5.498 13.12H6.86L4.154 11.89c-.164-.646-.307-.882-.806-1.154C2.532 10.294 1.185 9.88 0 9.621l.08-.381h5.775c.736 0 1.398.49 1.565 1.337l1.43 7.592 3.531-8.93h3.565zm14.057 8.836c.014-3.463-4.788-3.654-4.755-5.2.01-.471.459-.972 1.44-1.1.486-.063 1.826-.112 3.346.588l.596-2.783A9.125 9.125 0 0027.455 9c-3.354 0-5.715 1.783-5.735 4.337-.022 1.888 1.685 2.942 2.97 3.57 1.323.643 1.767 1.056 1.762 1.63-.01.88-1.055 1.27-2.032 1.284-1.706.027-2.696-.461-3.485-.828l-.615 2.874c.793.364 2.257.681 3.774.697 3.566 0 5.898-1.76 5.91-4.488zm8.858 4.283H42L39.26 9.24h-2.897c-.651 0-1.2.38-1.444.963L29.826 22.36h3.564l.707-1.96h4.354l.41 1.96zm-3.787-4.649l1.787-4.925 1.028 4.925h-2.815zM20.796 9.24l-2.807 13.12h-3.393l2.807-13.12h3.393z",
    fill: "#1434CB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.9e3995fcc368890650dfb9228572177c.svg";
export { ForwardRef as ReactComponent };